import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Content, { HTMLContent } from "../components/Content";
import Layout from "../components/Layout";

// eslint-disable-next-line
export const ArtistPageTemplate = ({ title, content, contentComponent }) => {
  const PageContent = contentComponent || Content

  return (
    <section className="section section--gradient">
      <div className="container">
        <div className="columns">
          <div className="column">
            <div className="section--artist">
              <PageContent className="about--description" content={content} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ArtistPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
};

const ArtistPage = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout>
      <ArtistPageTemplate
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
      />
    </Layout>
  );
};

ArtistPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ArtistPage;

export const artistPageQuery = graphql`
  query ArtistPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`;
